import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import TrackedKeywordsCount from "../../components/TrackedKeywords/TrackedKeywordsCount";
import TrackedKeywordsOverview from "../../components/TrackedKeywords/TrackedKeywordsOverview";
import { fetchTrackedKeywordsCount } from "../../store/tracked_keywords/operations";
import { getTrackedKeywordsCount, isFetchingKeywordsCount } from "../../store/tracked_keywords/selectors";
import { getSelectedWebsiteDomain, getSelectedWebsiteRegionalDatabase } from "../../store/tracked_websites/selectors";
import { getMaxKeywordsNo } from "../../store/sales/selectors";

class KeywordPositionTracker extends Component {
  componentDidMount = _ => {
    this.props.fetchTrackedKeywordsCount();
  };
  render() {
    return (
      <div>
        <TrackedKeywordsCount
          isLoading={this.props.isFetchingKeywordsCount}
          keywordsCount={this.props.keywordsCount}
          maxKeywordsNo={this.props.maxKeywordsNo}
          push={this.props.push}
        />
        <TrackedKeywordsOverview domain={this.props.domain} seoDb={this.props.seoDb} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  domain: getSelectedWebsiteDomain(state),
  seoDb: getSelectedWebsiteRegionalDatabase(state),
  isFetchingKeywordsCount: isFetchingKeywordsCount(state),
  keywordsCount: getTrackedKeywordsCount(state),
  maxKeywordsNo: getMaxKeywordsNo(state)
});

export default connect(
  mapStateToProps,
  {
    fetchTrackedKeywordsCount, push
  }
)(KeywordPositionTracker);
